// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__B_Yzj","file":"styles_file__1C0V5"};